import React, { Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainHeader from '../../../layouts/header/main-header/header-one';
import { currency } from '../../../components/utils/currency_array';
import StickyHeader from '../../../layouts/header/sticky-header/header-one';
import MobileHeader from '../../../layouts/header/mobile-header/header-one';
import MobileFooter from '../../../layouts/footer/mobile-footer';
import MainFooter from '../../../layouts/footer/main-footer';
import ArrowBackToTop from '../../../components/arrow-backToTop';
import Switcher from '../../../components/switcher';
import NewsLetterModal from '../../../components/newslatter-modal';
import Cookies from '../../../components/cookies';
import { useTranslation } from 'react-i18next';

const Blog_Single_Post = () => {
  const { t, i18n } = useTranslation();

  // save currency state from localStorage
  const [currencyDetail, setCurrencyDetail] = useState('');
  useEffect(() => {
    ///////////////// ===== save currency varible in localStroge for currency changed
    //=== get currency from storage
    let LocalCurrencyDetail = JSON.parse(localStorage.getItem('currency'));

    if (LocalCurrencyDetail === null || LocalCurrencyDetail === undefined) {
      localStorage.setItem('currency', JSON.stringify(currency[0]));
      LocalCurrencyDetail = JSON.parse(localStorage.getItem('currency'));
    }
    setCurrencyDetail(LocalCurrencyDetail);
  }, []);

  const onChangeCurrencies = i => {
    // ===== save currency varible in localStroge for currency changed
    localStorage.setItem('currency', JSON.stringify(currency[i]));
    const LocalCurrencyDetail = JSON.parse(localStorage.getItem('currency'));
    setCurrencyDetail(LocalCurrencyDetail);
  };
  /////////////////////////////////////

  return (
    <Fragment>
      {/* Paste this code after body tag */}
      {/* <div className="se-pre-con" /> */}
      {/* //Header Style One */}
      <MainHeader
        onCurrencyChanged={onChangeCurrencies}
        currencyDetails={currencyDetail}
      />
      {/* //Sticky Header */}
      <StickyHeader
        onCurrencyChanged={onChangeCurrencies}
        currencyDetails={currencyDetail}
      />
      {/* //Mobile Header */}
      <MobileHeader
        onCurrencyChanged={onChangeCurrencies}
        currencyDetails={currencyDetail}
      />
      {/* Site Content */}
      <div className='container-fuild'>
        <nav aria-label='breadcrumb'>
          <div className='container'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item'>
                <Link to='#'>{t('Home.1')}</Link>
              </li>
              <li className='breadcrumb-item active' aria-current='page'>
                {t('Blog.1')}
              </li>
            </ol>
          </div>
        </nav>
      </div>
      <section className='pro-content blog-content blog-content-page'>
        <div className='container'>
          <div className='row'>
            <div className='pro-heading-title'>
              <h1>{t('Blog Single Page.1')}</h1>
            </div>
          </div>
          <div className='row'>
            <div className='col-12 col-lg-8'>
              <div className='blog-area'>
                <div className='row'>
                  <div className='col-12 col-sm-12'>
                    <div className='blog'>
                      <div className='blog-thumbnail'>
                        <div className='blog-date'>
                          30
                          <small>{t('Dec.1')}</small>
                        </div>
                        <img
                          className='img-thumbnail'
                          src='assets/images/blogs/blog_post_1.jpg'
                          alt='Thumbnail'
                        />
                      </div>
                      <h1>
                        <Link to='#'>
                          {t(
                            'Woman wearing Silver-colore ring pendant necklaces.1'
                          )}
                        </Link>
                        <br />
                      </h1>
                      <p className='text-wrap'>
                        {t(
                          'orem ipsum dolor sit amet, consectetur adipiscing elit, Sed sit amet diam tristique, porttitor metus in, vehicula nisl, Vestibulum vel urna vel dolor euismod placerat, Nam at ex euismod, accumsan velit ut, pretium mi, Fusce sit amet consequat nisi, vitae venenatis leo, Duis pellentesque vulputate commodo, Vivamus vel ligula fermentum, malesuada augue ut, luctus lacus, Donec lacinia scelerisque magna eu malesuada, Pellentesque mollis finibus massa, Donec sed ultricies ex, Phasellus vel lorem eget nulla sagittis posuere.1'
                        )}
                        <br />
                        {t(
                          'Sed convallis magna in tortor fermentum, sit amet accumsan diam malesuada, Aliquam urna turpis, sodales et tempor nec, dignissim eu odio, Vivamus et mattis urna, Praesent ullamcorper ut est non lobortis, Praesent dignissim et erat a luctus, Pellentesque imperdiet, lacus quis euismod elementum, est quam sagittis tellus, sit amet ullamcorper erat nibh a dolor, Proin tincidunt eu sapien quis sollicitudin, In a turpis sed tortor semper imperdiet, Duis eu interdum enim.1'
                        )}
                        <br />
                        {t(
                          'Donec rutrum nunc eros, Vivamus eu massa dignissim, interdum dolor ac, commodo nibh, Phasellus ipsum justo, ullamcorper nec fringilla ut, condimentum vel elit, Mauris tincidunt dui eu velit dapibus, tempor blandit massa accumsan, Sed vitae ante ultricies, dapibus diam at, congue quam, Aliquam at eros turpis, Sed molestie feugiat tristique, Duis molestie eu tortor ut pretium, Duis risus felis, pretium ut porta id, mattis a tellus, Quisque convallis urna in pharetra cursus, Maecenas vitae vulputate lorem, Vivamus vestibulum imperdiet lacus, sit amet vehicula justo placerat non, Maecenas cursus lorem nibh, a efficitur nulla facilisis in.1'
                        )}
                        <br />
                        {t(
                          'Curabitur ac quam sed neque mattis fringilla, Proin arcu justo, vehicula ac eros placerat, efficitur scelerisque eros, Nulla ut mollis enim, Proin lobortis aliquet ultrices, Donec varius sem ut feugiat convallis, Aliquam sodales nibh pulvinar risus aliquam, vitae consectetur dolor efficitur, Suspendisse aliquam dolor eget nulla finibus tincidunt eget in eros, Integer pharetra posuere dolor in aliquet, Nulla nec gravida dolor, Mauris imperdiet quis risus sed consectetur, Aenean in ante ultrices dui elementum interdum ac in nunc, Etiam aliquet accumsan nunc ac rhoncus, Vivamus auctor lectus sed sem rhoncus, id dignissim risus fermentum, Duis at libero porta, pharetra neque at, egestas est, Praesent sem odio, fermentum eu suscipit in, sollicitudin quis libero.1'
                        )}
                      </p>
                      <h2>{t('sit amet accumsan diam malesuada.1')}</h2>
                      <p className='text-wrap'>
                        {t(
                          'Curabitur ac quam sed neque mattis fringilla, Proin arcu justo, vehicula ac eros placerat, efficitur scelerisque eros, Nulla ut mollis enim, Proin lobortis aliquet ultrices, Donec varius sem ut feugiat convallis, Aliquam sodales nibh pulvinar risus aliquam, vitae consectetur dolor efficitur, Suspendisse aliquam dolor eget nulla finibus tincidunt eget in eros, Integer pharetra posuere dolor in aliquet, Nulla nec gravida dolor, Mauris imperdiet quis risus sed consectetur, Aenean in ante ultrices dui elementum interdum ac in nunc, Etiam aliquet accumsan nunc ac rhoncus, Vivamus auctor lectus sed sem rhoncus, id dignissim risus fermentum, Duis at libero porta, pharetra neque at, egestas est, Praesent sem odio, fermentum eu suscipit in, sollicitudin quis libero.1'
                        )}
                        <br />
                        {t(
                          'Sed convallis magna in tortor fermentum, sit amet accumsan diam malesuada, Aliquam urna turpis, sodales et tempor nec, dignissim eu odio, Vivamus et mattis urna, Praesent ullamcorper ut est non lobortis, Praesent dignissim et erat a luctus, Pellentesque imperdiet, lacus quis euismod elementum, est quam sagittis tellus, sit amet ullamcorper erat nibh a dolor, Proin tincidunt eu sapien quis sollicitudin, In a turpis sed tortor semper imperdiet, Duis eu interdum enim.1'
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 col-lg-4  d-lg-block d-xl-block blog-menu'>
              <div className='block'>
                <div className='pro-heading-subtitle'>
                  <h4>{t('Recent Posts.1')}</h4>
                </div>
                <div className='media'>
                  <img
                    src='assets/images/miscellaneous/avatar.jpg'
                    alt='Avatar'
                    style={{ width: 68, height: 68 }}
                  />
                  <div className='media-body'>
                    <h6>
                      <Link to='#'>
                        {t(
                          'Gold bangle is worn on top of the engagement band.1'
                        )}
                      </Link>
                    </h6>
                    <p>
                      {t(
                        'Lorem ipsum sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.1'
                      )}
                    </p>
                  </div>
                </div>
                <div className='media'>
                  <img
                    src='assets/images/miscellaneous/avatar.jpg'
                    alt='Avatar'
                    style={{ width: 68, height: 68 }}
                  />
                  <div className='media-body'>
                    <h6>
                      <Link to='#'>
                        {t(
                          'Woman wearing all kind of silver colore jewelery.1'
                        )}
                      </Link>
                    </h6>
                    <p>
                      {t(
                        'Lorem ipsum sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.1'
                      )}
                    </p>
                  </div>
                </div>
                <div className='media'>
                  <img
                    src='assets/images/miscellaneous/avatar.jpg'
                    alt='Avatar'
                    style={{ width: 68, height: 68 }}
                  />
                  <div className='media-body'>
                    <h6>
                      <Link to='#'>
                        {t('White gold engagement rings for couples.1')}
                      </Link>
                    </h6>
                    <p>
                      {t(
                        'Lorem ipsum sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.1'
                      )}
                    </p>
                  </div>
                </div>
              </div>
              <div className='block'>
                <div className='pro-heading-subtitle'>
                  <h4>{t('Latest Comments.1')}</h4>
                </div>
                <div className='media'>
                  <i className='fas fa-comments' />
                  <div className='media-body'>
                    <p>
                      <Link to='#'>
                        {t('Lorem ipsum dolor sit amet, consectetur aliqua.1')}
                      </Link>
                    </p>
                    <span>
                      <i className='far fa-clock' />
                      {t('Dec 25,2019.1')}
                    </span>
                  </div>
                </div>
                <div className='media'>
                  <i className='fas fa-comments' />
                  <div className='media-body'>
                    <p>
                      <Link to='#'>
                        {t(
                          'Lorem ipsum sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.1'
                        )}
                      </Link>
                    </p>
                    <span>
                      <i className='far fa-clock' />
                      {t('Dec 25,2019.1')}
                    </span>
                  </div>
                </div>
                <div className='media'>
                  <i className='fas fa-comments' />
                  <div className='media-body'>
                    <p>
                      <Link to='#'>
                        {t(
                          'Adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.1'
                        )}
                      </Link>
                    </p>
                    <span>
                      <i className='far fa-clock' />
                      {t('Dec 25,2019.1')}
                    </span>
                  </div>
                </div>
              </div>
              <div className='block'>
                <div className='pro-socials'>
                  <h4>{t('Stay Connected.1')}</h4>
                  <ul>
                    <li>
                      <Link to='#' className='fab fb fa-facebook-square' />
                    </li>
                    <li>
                      <Link to='#' className='fab tw fa-twitter-square' />
                    </li>
                    <li>
                      <Link to='#' className='fab sk fa-skype' />
                    </li>
                    <li>
                      <Link to='#' className='fab ln fa-linkedin' />
                    </li>
                    <li>
                      <Link to='#' className='fab ig fa-instagram' />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Mobile */}
      <MobileFooter />
      {/* //footer style three */}
      <MainFooter />
      {/* arrow back to top */}
      <ArrowBackToTop />
      {/* change color switcher */}
      <Switcher />
      {/* Newsletter Modal */}
      <NewsLetterModal />
      {/* cookies section */}
      <Cookies />
    </Fragment>
  );
};

export default Blog_Single_Post;
